export const IconGoogleLogo = () => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.1933 16.4172H19.7856V21.9279H27.445C27.1147 23.7092 26.1128 25.2158 24.6024 26.2252C23.3259 27.0787 21.6968 27.5834 19.7819 27.5834C16.0747 27.5834 12.939 25.0785 11.8183 21.7127C11.5362 20.8592 11.3729 19.9463 11.3729 19.0074C11.3729 18.0686 11.5362 17.1557 11.8183 16.3021C12.9427 12.94 16.0784 10.4352 19.7856 10.4352C21.8749 10.4352 23.7489 11.1551 25.2259 12.5652L29.3079 8.47949C26.8401 6.17871 23.6228 4.76855 19.7856 4.76855C14.2229 4.76855 9.40986 7.95996 7.06826 12.6135C6.10342 14.5357 5.5542 16.7104 5.5542 19.0111C5.5542 21.3119 6.10342 23.4828 7.06826 25.4051C9.40986 30.0586 14.2229 33.25 19.7856 33.25C23.6302 33.25 26.8513 31.9734 29.204 29.7988C31.8944 27.3199 33.4493 23.6684 33.4493 19.3303C33.4493 18.3209 33.3603 17.3523 33.1933 16.4172Z"
      fill="white"
    />
  </svg>
);
